import numeral from 'numeral';

const formatAmount = (num: string | number): string =>
  numeral(num).format('$0,0[.]00a').toLocaleUpperCase();

export default formatAmount;
